export const ACCESS_TOKEN_LOCAL_STORAGE_KEY = "biz-jwt-token";
export const REFRESH_TOKEN_LOCAL_STORAGE_KEY = "biz-refresh-token";
export const RETURN_PATH_LOCAL_STORAGE_KEY = "return-url";
export const SUBBUSINESS_ID_LOCAL_STORAGE_KEY = "sub-business-id";
export const GRECAPTCHA_STORAGE_KEY = "_grecaptcha";

export const CONFIG_STORAGE_KEY = "CONFIG";
export const T_RESOURCES_STORAGE_KEY = "T_RESOURCES";
export const SETTINGS_STORAGE_KEY = "SETTINGS";
